import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import flexible from 'lib-flexible'
import axios from 'axios'
import APIS from './apis'
import {mapMutations} from 'vuex'
import qs from 'qs'
import Toasted from '@gitlab/vue-toasted'
import VueTouch from 'vue-touch'
import VueWechatTitle from 'vue-wechat-title'

Vue.use(VueWechatTitle)
Vue.use(VueTouch, {name: 'v-touch'});

Vue.use(Toasted, {
  theme: "toasted-primary", 
  position: "top-center", 
  duration : 3000
})

window.iphone8 = false;
let winHeight = window.innerHeight;
console.log('window height', winHeight);
if (winHeight > 680) {
  iphone8 = true;
}

axios.defaults.withCredentials = true
axios.interceptors.response.use(
  res => {
    console.log(res)
    if (res.data.errcode == 1001) {
      window.app.shouquan()
    }
    return res
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

Vue.config.productionTip = false

Vue.prototype.$axios = axios
Vue.prototype.$apis = APIS
Vue.prototype.$qs = qs
Vue.prototype.$IPX_NUM = 680

window.wxmp = 'ceping';

Vue.mixin({
  computed: {
    ceshi() {
      return this.$store.state.ceshi
    },
    questions() {
      return JSON.parse(this.ceshi.questions)
    },
    results() {
      return JSON.parse(this.ceshi.results)
    },
    pagemeta() {
      return JSON.parse(this.ceshi.pagemeta)
    },
    userResult() {
      return this.$store.state.userResult
    },
    tuijians() {
      return JSON.parse(this.ceshi.tuijians);
    },
  },
  methods: {
    ...mapMutations([
      'setCeshi',
      'setUser',
      'setUserResult',
    ]),
    isodd(val) {
      return val % 2 > 0
    },
    getQueryString(name, val = null) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      if (val != null) return val;
      return null;
    },
    shouquan() {
      let tt = new Date().getTime();
      let baseurl = location.href.split('#')[0];
      if (baseurl.indexOf('tt=') < 0) {
        if (baseurl.indexOf('?') > 0) {
          baseurl += '&'
        } else {
          baseurl += '?'
        }
        baseurl = `${baseurl}tt=${tt}`
      }
      let callback =  baseurl + location.hash;
      console.log('callback', callback);
      let href = APIS.shouquan + `?wxmp=${window.wxmp}&callback=` + encodeURIComponent(callback);
      console.log(location.href)
      console.log(href)
      window.location.href = href;
    },
    postEvent(name) {
      if (!window.unionid) {
        return;
      }
      let url = this.$apis.event;
      this.$axios.post(url, qs.stringify({
        idcode: this.ceshi.idcode,
        name,
        unionid: window.unionid,
        }))
    },
    getWechatData() {
      let that = this
      let url = this.$apis.jsconfig
      this.$axios.get(url, {
        params: {
            url: location.href.split('#')[0],
            wxmp: "8y8bwt",
        }
      }).then(function (res) {
        if (res.data.errcode == 0) {
          let data = res.data.data;
          wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: data.appId, // 必填，公众号的唯一标识
              timestamp: data.timestamp, // 必填，生成签名的时间戳
              nonceStr: data.nonceStr, // 必填，生成签名的随机串
              signature: data.signature, // 必填，签名，见附录1
              jsApiList: [
                  'updateAppMessageShareData',
                  'updateTimelineShareData',
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
        }
      })
    },
    initWx(shareConfig) {
      wx.ready(function () {
          console.log('wx ready')
          wx.updateAppMessageShareData({
              title: shareConfig.title, // 分享标题
              desc: shareConfig.desc, // 分享描述
              link: shareConfig.link, // 分享链接
              imgUrl: shareConfig.imgUrl, // 分享图标
              // success: shareConfig.success,
              // cancel: shareConfig.cancel
          })
          wx.updateTimelineShareData({
              title: shareConfig.title, // 分享标题
              // desc: shareConfig.desc, // 分享描述
              link: shareConfig.link, // 分享链接
              imgUrl: shareConfig.imgUrl, // 分享图标
              // type: 'link', // 分享类型,music、video或link，不填默认为link
              // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
              // success: shareConfig.success,
              // cancel: shareConfig.cancel
          })
      });
    },
    initBgAudio() {
      console.log('initBgAudio', this.pagemeta);
      if (!this.pagemeta) {
        return;
      }
      let music = this.pagemeta.music;
      if (!music) {
        return;
      }
      console.log('initBgAudio', music);
      window.bgaudio = new Audio(music);
      bgaudio.preload = 'auto';
      bgaudio.loop = true;
    },
    playBgAudio() {
      console.log('autoplay', window.bgaudio);
      if (!window.bgaudio) {
        return;
      }
      window.bgaudio.volume = 1;
      window.bgaudio.play();
    },
    getUser(callback) {
      let that = this
      let url = this.$apis.userGet
      this.$axios.get(url).then(res => {
        if (res.data.errcode == 0) {
          that.setUser(res.data.data)
        }
        if (callback) {
          callback(res)
          return
        }
      })
    },
    isEmpObj: function (obj) {
      for (let t in obj) {
          return false;
      }
      return true;
    },
  }
})

window.app = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')